<div class="pna-pagecontainer">
  <div class="pna-divcontainer">
    <i class="fa-solid fa-lock pna-icon" aria-hidden="true"></i>
    <div class="pna-sorry">Sorry, you do not have an active license.</div>
    <div class="pna-detail">
      Please contact your ISG ProBenchmark support team — <a href="javascript:void(0)" (click)="contactSupport()">click here</a> to request access.
    </div>
  </div>
  <isg-loader *ngIf="contactSupportService.isOpening()"></isg-loader>
</div>
